import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
const Services = ({ showHeader = true }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div>

      {/* HEADER */}
      {showHeader && (
        <section className="page-header">
          <div className="header-container">
            <h1>Our Services</h1>
            <p>Know More About Our Services</p>
          </div>
        </section>
      )}

      {/* MOBILE DEVELOPMENT */}
      <section id="mobile" className="service-section">

        <div className="service-left">
          <p className="service-tag">SERVICES</p>
          <h2 className="service-title">Mobile Development</h2>

          <ul className="service-list">
            <li>
              <i className="bi bi-apple"></i>
              IOS Development
            </li>

            <li>
              <i className="bi bi-android2"></i>
              Android Development
            </li>

            <li>
              <i className="bi bi-phone"></i>
              Flutter Development
            </li>

            <li>
              <i className="bi bi-badge-vr"></i>
              AR/VR Development
            </li>
          </ul>
        </div>

        <div className="service-right">
          <h2>Mobile App Development</h2>

          <p>
            We provide powerful mobile app solutions to help businesses grow
            digitally with innovative and scalable applications.
          </p>

           <Link to="/portfolio#mobile" className="explore-btn">
            Explore →
          </Link>
          <div className="service-image">
            <img
              src="/images/1.png"
              alt="mobile-app"
            />
          </div>
        </div>

      </section>


      {/* WEB DEVELOPMENT */}
      <section id="web"  className="service-section reverse">


        <div className="service-right">
          <p className="service-tag">SERVICES</p>
          <h1 className="service-title">Web Development</h1>

          <ul className="service-list">
            <li>
              <i className="bi bi-filetype-php"></i>
              PHP Web Development
            </li>

            <li>
              <i className="bi bi-code-slash"></i>
              React Js Development
            </li>

            <li>
              <i className="bi bi-node-plus"></i>
              Node Js Development
            </li>

            <li>
              <i className="bi bi-globe"></i>
              .Net Development
            </li>
          </ul>
          
        </div>
        
      
        <div className="service-right">
          <h2>Web Development</h2>

        <p>
  We build modern, scalable and responsive websites tailored to your
  business needs, helping you improve performance and deliver a
  seamless user experience.
</p>

         <Link to="/portfolio#web" className="explore-btn">
            Explore →
          </Link>

          <div className="service-image">
            <img
              src="images/web-development-banner.png"
              alt="web development"
            />
          </div>
        </div>

      </section>


      {/* UI UX DESIGN */}
      <section id="uiux" className="service-section">

        <div className="service-left">
          <p className="service-tag">SERVICES</p>
          <h2 className="service-title">UI/UX & Graphic Design</h2>

          <ul className="service-list">

            <li>
              <i className="bi bi-palette"></i>
              User Interface (UI) Design
            </li>

            <li>
              <i className="bi bi-bezier"></i>
              User Experience (UX) Design
            </li>

            <li>
              <i className="bi bi-grid-3x3"></i>
              Prototyping
            </li>

            {/* <li>
              <i className="bi bi-brush"></i>
              Illustration
            </li> */}

            <li>
              <i className="bi bi-vector-pen"></i>
              Logo / Icon Design
            </li>
{/* 
            <li>
              <i className="bi bi-film"></i>
              Motion / Animation
            </li> */}

          </ul>
        </div>

        <div className="service-right">
          <h2>UI/UX Design</h2>

          <p>
            We design visually stunning, engaging, meaningful & user-friendly
            customer experiences for your target audience.
          </p>

           <Link to="/portfolio#uiux" className="explore-btn">
            Explore →
          </Link>

          <div className="service-image">
            <img
              src="/images/uiuxbanner.png"
              alt="uiux design"
            />
          </div>
        </div>

      </section>

      {/* DIGITAL MARKETING */}
<section id="marketing" className="service-section reverse">

  <div className="service-right">
    <p className="service-tag">SERVICES</p>
    <h2 className="service-title">Digital Marketing</h2>

    <ul className="service-list">

      <li>
        <i className="bi bi-search"></i>
        Search Engine Optimization (SEO)
      </li>

      <li>
        <i className="bi bi-megaphone"></i>
        Social Media Marketing
      </li>

      <li>
        <i className="bi bi-google"></i>
        Google Ads Campaign
      </li>

      <li>
        <i className="bi bi-instagram"></i>
        Facebook & Instagram Ads
      </li>

      <li>
        <i className="bi bi-graph-up"></i>
        Analytics & Reporting
      </li>

    </ul>
  </div>


  <div className="service-right">
    <h2>Digital Marketing</h2>

<p>
  We deliver powerful digital marketing strategies to grow your brand
  online. From SEO optimization to social media and paid advertising,
  we help businesses achieve measurable results.
</p>
    <div className="service-image">
      <img
        src="/images/4.png"
        alt="Digital Marketing"
      />
    </div>
  </div>

</section>

    </div>
  );
};

export default Services;